<template>
	<MoleculeCard
		:icon="icon"
		:title="title"
		:description="description"
		:link="link"
	/>
</template>

<script setup lang="ts">
import type { FontAwesomeIconType } from '#base/app/plugins/fontawesome';
import type { LinkType } from '#base/core/types/LinkType';

defineProps<{
	title: string;
	link?: LinkType;
	description: string;
	icon: FontAwesomeIconType;
}>();
</script>
